import { TransactionCodesFiltersData } from '@hkm/components/Posting/PostingView/filters/TransactionCodesFiltersData';
import { createCombinedApiFilters } from '@hkm/shared/helpers/apiFilter/apiCombinedFiltersFactory';
import {
  ApiFiltersFactoryConfig,
  createApiFilters
} from '@hkm/shared/helpers/apiFilter/apiFiltersFactory';

import { FIQLOperators, TransactionCode2 } from '@ac/library-api';

const filterMap = new Map<
  keyof TransactionCodesFiltersData,
  ApiFiltersFactoryConfig<TransactionCode2>
>()
  .set('allowManualPosting', {
    field: 'allowManualPosting'
  })
  .set('defaultPostingValue', {
    field: 'defaultPostingValue',
    customOperator: FIQLOperators.greaterThenOrEqual
  })
  .set('isActive', {
    field: 'isActive'
  })
  .set('isNonRevenue', {
    field: 'isNonRevenue'
  })
  .set('isPostingAllowed', {
    field: 'isPostingAllowed'
  });

export function createTransactionCodesApiFilter(
  filters: TransactionCodesFiltersData
): string | undefined {
  return createCombinedApiFilters(
    ...createApiFilters<TransactionCodesFiltersData, TransactionCode2>(
      filters,
      filterMap
    )
  );
}



// WEBPACK FOOTER //
// ./src/components/Posting/PostingView/filters/TransactionCodesApiFilterFactory.ts